var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled from 'styled-components';
var Category = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 0.9em;\n  font-weight: ", ";\n  letter-spacing: 2px;\n  padding-bottom: 0.25em;\n  padding-left: 1.75em;\n  padding-top: 2.5em;\n  text-transform: uppercase;\n  width: 100%;\n"], ["\n  color: ", ";\n  font-size: 0.9em;\n  font-weight: ", ";\n  letter-spacing: 2px;\n  padding-bottom: 0.25em;\n  padding-left: 1.75em;\n  padding-top: 2.5em;\n  text-transform: uppercase;\n  width: 100%;\n"])), function (p) {
  return p.theme.textTertiary;
}, function (p) {
  return p.theme.fontWeightBold;
});

var NavCategory = function NavCategory(_a) {
  var children = _a.children;
  return React.createElement(Category, {
    className: "nav-category"
  }, children);
};

export default NavCategory;
var templateObject_1;